import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import { categories, mangaWorks } from "@/mocks/manga";

export default function CategoryNav() {
  const countBy = (id: string) => (id === "all" ? mangaWorks.length : mangaWorks.filter((w) => w.category === id).length);

  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          title="分类浏览"
          subtitle="按兴趣挑漫画，总有一部适合你"
          moreLink="/category/all"
          moreText="分类"
        />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              title={`${cat.name}漫画`}
              className="group flex items-center gap-3.5 rounded-lg border border-background-200/70 bg-background-100 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300/60"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={cat.icon}></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <strong className="text-sm font-bold text-foreground-950">{cat.name}漫画</strong>
                  <span className="whitespace-nowrap rounded-full bg-accent-100 px-1.5 py-0.5 text-[10px] font-bold text-accent-700">
                    {countBy(cat.id)}部
                  </span>
                </span>
                <span className="mt-0.5 block truncate text-[11px] text-foreground-600">{cat.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}